// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".form-label .text[data-v-c48a63fa]{white-space:pre-wrap;word-wrap:break-word}.form-label .error-message[data-v-c48a63fa],.form-label .text[data-v-c48a63fa]{margin:0!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
